<template>
    <div class="simulationChart" v-loading="loader" :element-loading-text="getText('global_user_information_latency')">
        <h3 class="chartTitle">{{getText('simulation_audit_stats_title')}}</h3>
        <div id="chart" ref="paChart"></div>
    </div>
</template>

<script>
import Plotly from 'plotly.js-basic-dist';
import {mapGetters} from 'vuex';



export default {

    props: {
        paData: {
            type: Array,
            required: true
        },
        start: {
            type: String,
            required: true
        },
        end: {
            type: String,
            required: true
        }
    },

    data: function(){
        return {
            loader: false,
            keys: null,
            moteurs: {},
        };
    },

    computed: {
        ...mapGetters([
            'getText'
        ]),
    },
    watch: {
        paData(val) {
            if (val.length) {
                this.loader = true;
                this.keys = JSON.parse(JSON.stringify(Object.keys(this.paData[0])));
                if (this.keys.indexOf('timestamps') >= 0) {
                    this.keys.splice(this.keys.indexOf('timestamps'), 1);// we remove the 'timestamps' entry
                }
                this.keys.forEach(key => {
                    this.$set(this.moteurs, key, {
                        x: [],
                        y: [],
                        mode: 'lines',
                        type: 'scatter',
                        name: key,
                        marker: { size: 4 }
                    });
                });
                this.createGraph();
            }
        }
    },

    methods: {
        resetStatsData() {
            this.keys.forEach(key => {
                this.moteurs[key].y = [];
                this.moteurs[key].x = [];
            });
        },
        createGraph() {
            let data = [];
            this.resetStatsData();
            this.paData.forEach(data => {
                this.keys.forEach(key => {
                    this.moteurs[key].y.push(data[key]);
                    this.moteurs[key].x.push(data.timestamps);
                });
            });

            this.keys.forEach(key => {
                data.push(this.moteurs[key]);
            });

            var options = {
                displaylogo: false,
                responsive: true,
            };

            var layout = {
                autosize: true,
                yaxis: {
                    title: this.getText('simulation_audit_ordinate')
                }
            };

            Plotly.react('chart', data, layout, options);
            this.loader = false;
        }
    },
};
</script>

<style lang="less">
@import '../../less/variables';

.simulationChart {
    height: 500px;

    .el-loading-mask {
        .el-loading-text {
            color: @color-1;
        }
    }
    .chartTitle {
        margin: auto;
        width: 85%;
        padding-left: 40px;
        display: block;
        text-align: left;
        font-size: 18px;
        color: #303133;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/page/simulationChart.vue